angular.module('rjmNg.directives').directive "adobeAnalyticsProfilePicker", [
  () ->
    restrict: "E"
    templateUrl: "directive.adobeAnalyticsProfilePicker.html"
    controllerAs: "view"
    bindToController: true
    scope:
      onCancel: "&"
      connection: "<"
      onSelectProfile: "&"
      onSetConnProperty: "&"
    controller: [
      "AdobeAnalytics"
      "app"
      "InputConnections"
      "notification"
      (
        AdobeAnalytics
        app
        InputConnections
        notification
      ) ->

        view = @

        # After changing this value UI will allow adding more than one report
        # suites per integration. Editing of existing report suites isn't supported
        view.NUM_OF_ALLOWED_REPORT_SUITES = 1

        view.isAddingReportSuite = true
        view.reportSuites = []
        view.isReportSuitesLoading = true
        view.profiles =
          isLoading: true
          data: []

        InputConnectionsInstance = InputConnections(app.getClientId())

        view.cancel = () ->
          view.onCancel()

        view.save = () ->
          guids = []
          for reportSuite in view.reportSuites
            guids.push(reportSuite.guid)

            view.onSetConnProperty(
              prop: reportSuite.guid
              value: JSON.stringify(reportSuite.data)
            )

          view.onSetConnProperty(
            prop: "report-suites",
            value: JSON.stringify(guids)
          )

          view.onSelectProfile({save: true})

        view.addReportSuite = () ->
          view.isAddingReportSuite = true

        view.cancelAddReportSuite = () ->
          view.isAddingReportSuite = false

        view.saveReportSuite = (profile, metrics, dimensions) ->
          reportSuite = AdobeAnalytics.makeReportSuite(
            profile.rsid,
            profile.name,
            metrics,
            dimensions
          )
          view.reportSuites.push(reportSuite)
          view.isAddingReportSuite = false



        _loadProfiles = () ->
          InputConnectionsInstance.getProfiles(
            view.connection.id,
            view.connection.type
            false
          ).then( (profiles) ->
            view.profiles.data = profiles
          ).catch( (error) ->
            notification.error(
              "Error",
              "There was a problem loading Adobe Analytics Report Suites.",
              "adobe-analytics-integration"
            )
          ).finally( () ->
            view.profiles.isLoading = false
          )

        _loadReportSuites = () ->
          AdobeAnalytics.fetchLocalTableNames(
            view.connection.meta_id
          ).then( (success) ->
            view.reportSuites = AdobeAnalytics.parseReportSuites(view.connection)
            if view.reportSuites.length > 0
              view.isAddingReportSuite = false
          ).catch( (error) ->
            notification.error(
              "Error",
              "There was a problem loading Local Table Names information.",
              "adobe-analytics-integration"
            )
          ).finally( () ->
            view.isReportSuitesLoading = false
          )

        @$onInit = () ->
          notification.clear("adobe-analytics-integration")
          _loadReportSuites()
          _loadProfiles()

        return view
    ]
    link: (scope, element, attr, view) ->

      scope.$on '$locationChangeStart', (event) ->
        leaveAdobeAnalyticsProfilePicker = confirm("Are you sure you want to leave without saving?")
        if not leaveAdobeAnalyticsProfilePicker
          event.preventDefault()
]
